// i18n area 'hci' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.ro-RO.meta.json.
import type { enUS } from './hci'

export const roRO: typeof enUS = {
  hci: {
    ceph: {
      title: 'Clustere Ceph',
      createButton: 'Creează cluster Ceph',
      emptyTitle: 'Niciun cluster Ceph gestionat',
      emptyBody: 'TVirt implementează și deține Ceph pe nodurile membre, hiperconvergent cu sarcina VM. Creează un cluster: primul monitor și managerul lui se nasc automat pe nodul de control ales — apoi crește-l cu alte monitoare și dispozitive OSD.',
      pageTitle: 'Clustere Ceph',
      colState: 'Stare',
      colMembers: 'Membri',
      colSize: 'Dimensiune',
      colVersion: 'Versiune Ceph',
      sizeCell: '{used} GiB folosiți din {total} GiB în total',
      phase: {
        'not-deployed': 'Neimplementat',
        deploying: 'Implementare în curs',
        healthy: 'Sănătos',
        degraded: 'Degradat',
        error: 'Eroare',
        destroying: 'În distrugere',
        destroyed: 'Distrus'
      },
      health: {
        HEALTH_OK: 'Sănătos (HEALTH_OK)',
        HEALTH_WARN: 'Cu avertismente (HEALTH_WARN)',
        HEALTH_ERR: 'În eroare (HEALTH_ERR)',
        unknown: 'Încă neobservată',
        observedAt: 'observată {time}'
      },
      create: {
        title: 'Creează cluster Ceph',
        info: 'La crearea unui nou cluster Ceph alegi primul nod pe care vor fi instalate rolurile MON și MGR. Trebuie specificată și subrețeaua prin care circulă traficul Ceph: subrețeaua public este folosită pentru traficul de rețea general, în timp ce subrețeaua cluster este folosită pentru replicile interne dintre OSD-uri; nu sunt neapărat necesare subrețele diferite.',
        controlNode: 'Nod de control',
        controlNodeHint: 'Nodul membru pe care se nasc primul MON + MGR.',
        publicSubnet: 'Subrețea public',
        publicSubnetHint: 'O Subnet înregistrată în IPAM — public_network a lui Ceph. Imuabilă după creare.',
        clusterSubnet: 'Subrețea cluster',
        clusterSubnetHint: 'O Subnet înregistrată în IPAM — cluster_network a lui Ceph (replicare/backfill).',
        noSubnets: 'Nicio Subnet înregistrată — creează-le mai întâi în IPAM',
        sameSubnet: 'Aceeași subrețea pentru traficul public și cluster',
        sameSubnetHint: 'Bifat = rețeaua cluster (replicare/backfill) coincide cu cea public. Nebifat = alege subrețeaua ei proprie ȘI adresa nodului de control în interiorul ei.',
        controlAddress: 'Adresa nodului de control',
        controlAddressHint: 'O adresă pe care IPAM o cunoaște pentru nod în subrețeaua public.',
        controlClusterAddress: 'Adresa cluster a nodului de control',
        controlClusterAddressHint: 'O adresă pe care IPAM o cunoaște pentru nod în subrețeaua cluster.',
        noAddresses: 'IPAM nu cunoaște nicio adresă a acestui nod în subrețeaua aleasă',
        started: 'Cluster creat — bootstrap-ul continuă ca macrotask; faza se actualizează singură',
        error: 'Clusterul a fost refuzat'
      },
      detail: {
        actions: 'Acțiuni disponibile',
        tabOverview: 'Prezentare generală',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pool-uri',
        tabObjects: 'Obiecte',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Avansate',
        phase: 'Fază',
        checksTitle: 'Check-uri de sănătate active',
        noChecks: 'Niciun check de sănătate activ',
        checkMuted: 'silențiat',
        summaryPools: 'Pool-uri',
        summaryFilesystems: 'Sisteme de fișiere',
        nodesCard: 'Noduri',
        monHint: 'Un MGR rulează colocat cu fiecare MON. Trei MON-uri sunt cvorumul recomandat; un cluster de laborator pornește cu unul. OSD-urile și MDS-urile trăiesc în filele lor.',
        monHintSplit: 'MON și MGR sunt disjuncți pe acest cluster (Avansate): fiecare rol este un membership propriu per nod. Trei MON-uri sunt cvorumul recomandat; cel puțin un MGR trebuie să existe.',
        noMons: 'Niciun monitor declarat',
        addNode: 'Adaugă nod',
        removeNode: 'Elimină nodul',
        removeNodeFrom: 'Elimină nodul {node} (MON-ul lui și MGR-ul colocat)',
        roleMon: 'Rol MON',
        roleMgr: 'Rol MGR',
        roleNa: 'N/A',
        roleNotObserved: 'încă neobservat',
        monInQuorum: 'în cvorum',
        monOutQuorum: 'în afara cvorumului',
        mgrActive: 'activ',
        mgrStandby: 'standby',
        addRoleMon: 'Adaugă rol MON',
        removeRoleMon: 'Elimină rolul MON',
        addRoleMgr: 'Adaugă rol MGR',
        removeRoleMgr: 'Elimină rolul MGR',
        restartMon: 'Repornește serviciul MON',
        restartMgr: 'Repornește serviciul MGR',
        addMon: 'Adaugă MON',
        removeMon: 'Elimină MON',
        removeMonFrom: 'Elimină rolul MON de pe {node}',
        addMgr: 'Adaugă MGR',
        removeMgr: 'Elimină MGR',
        removeMgrFrom: 'Elimină rolul MGR de pe {node}',
        addMds: 'Adaugă MDS',
        removeMds: 'Elimină MDS',
        removeMdsFrom: 'Elimină rolul MDS de pe {node}',
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Niciun MDS declarat — un sistem de fișiere cere mai întâi unul',
        mdsHint: 'Membership-ul MDS este propriu din prima zi: un cluster fără CephFS nu declară niciunul, un activ plus un standby servesc bine un sistem de fișiere. Ceph alege activii și standby-urile dintre daemonii declarați.',
        mdsActiveFor: 'activ — {fs}',
        mdsNotObserved: 'încă neobservat',
        lastMdsGuard: 'Ultimul MDS nu poate fi eliminat cât timp există un sistem de fișiere — elimină mai întâi sistemele de fișiere',
        lastMonGuard: 'Ultimul MON nu poate fi eliminat — distrugerea clusterului este singura ieșire',
        lastMgrGuard: 'Ultimul MGR nu poate fi eliminat — un cluster gestionat nu rulează niciodată fără manager',
        registerDevice: 'Adaugă OSD',
        unregisterDevice: 'Anulează înregistrarea',
        activeDeviceGuard: 'OSD activ — iese prin ciclul de viață OSD, nu din registru',
        colNode: 'Nod',
        devicePhase: { registered: 'Înregistrat', active: 'Activ' },
        health: 'Sănătate',
        state: 'Stare',
        fsid: 'fsid',
        fsidPending: 'absent — reîncearcă bootstrap-ul',
        version: 'Versiune Ceph',
        publicNetwork: 'Rețea public',
        clusterNetwork: 'Rețea cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'Nicio acțiune disponibilă în această fază',
        destroyedNote: 'Cluster distrus — rândul este eliminat automat în scurt timp'
      },
      overview: {
        services: 'Servicii',
        ok: 'sănătos',
        warning: 'warning',
        down: 'down',
        pgTitle: 'Stările PG',
        pgTotal: '{n} PG în total',
        capacityTitle: 'Spațiu',
        ioTitle: 'I/O curent',
        ioReadBw: 'Lățime de bandă la citire',
        ioWriteBw: 'Lățime de bandă la scriere',
        ioReadIops: 'IOPS la citire',
        ioWriteIops: 'IOPS la scriere',
        notObserved: 'încă neobservat'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Stare',
        colSize: 'Dimensiune',
        colPgs: 'PG',
        empty: 'Niciun OSD — adaugă unul dintr-un disc de date declarat',
        markIn: 'Marchează IN',
        markOut: 'Marchează OUT',
        scrub: 'Rulează scrub',
        deepScrub: 'Rulează scrub profund',
        restart: 'Repornește serviciul',
        details: 'Detalii',
        actionGuard: 'Doar pe un OSD activ al unui cluster implementat',
        inTitle: 'Marchează OSD IN',
        inBody: 'osd.{id} revine în distribuția datelor (ceph osd in): Ceph reechilibrează datele înapoi pe el.',
        outTitle: 'Marchează OSD OUT',
        outBody: 'osd.{id} iese din distribuția datelor (ceph osd out): datele lui se reechilibrează în altă parte, iar redundanța este REDUSĂ cât timp rulează backfill-ul. Reversibil în orice moment cu Marchează IN.',
        scrubTitle: 'Planifică scrub',
        scrubBody: 'Se planifică un scrub al osd.{id}: mon-ul îl pune în coadă, iar stările PG din sweep-urile următoare arată rezultatul.',
        deepScrubTitle: 'Planifică scrub profund',
        deepScrubBody: 'Se planifică un scrub profund al osd.{id}: varianta care verifică octeții — mai grea pe I/O, aceeași mecanică.',
        restartTitle: 'Repornește serviciul OSD',
        restartBody: 'osd.{id} este oprit și pornit din nou prin supervizarea proprie a workerului pe nodul lui.',
        started: 'Acțiune pornită — observația se actualizează singură',
        error: 'Acțiunea OSD a fost refuzată'
      },
      osdDetail: {
        title: 'Detalii OSD',
        tabGeneral: 'General',
        tabNetwork: 'Rețea',
        tabDevices: 'Dispozitive',
        version: 'Versiune',
        hostname: 'Hostname',
        dataPath: 'Cale de date OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Criptat',
        yes: 'Da',
        no: 'Nu',
        memory: 'Utilizare memorie (PSS)',
        pid: 'Process ID (PID)',
        front: 'Adresă front (client & monitor)',
        hbFront: 'Adresă heartbeat front',
        back: 'Adresă back (OSD)',
        hbBack: 'Adresă heartbeat back',
        colDevice: 'Device',
        colType: 'Tip',
        colPhysical: 'Device fizic',
        colSize: 'Dimensiune',
        volumeTitle: 'Detalii volum',
        creationTime: 'Data creării',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Niciun device observat pentru acest OSD'
      },
      restart: {
        title: 'Repornește serviciul',
        monBody: 'Daemonul MON de pe {node} este oprit și pornit din nou prin supervizarea proprie a workerului.',
        mgrBody: 'Daemonul MGR de pe {node} este oprit și pornit din nou prin supervizarea proprie a workerului.',
        started: 'Repornire pornită — observația se actualizează singură',
        error: 'Repornirea a fost refuzată'
      },
      encryptionMode: {
        alwaysOn: 'Mereu activată (dmcrypt)',
        alwaysOff: 'Mereu dezactivată',
        perOsd: 'Aleasă per OSD',
        section: 'Criptare OSD at rest',
        title: 'Schimbă modul de criptare OSD',
        hint: 'Cum sunt pregătite OSD-urile NOI. OSD-urile existente își păstrează starea per-disc: pentru a o schimba, elimini și recreezi OSD-ul.',
        body: 'Modul devine „{mode}” și se aplică DOAR OSD-urilor NOI: fiecare OSD existent își păstrează starea actuală de criptare.',
        apply: 'Schimbă modul',
        error: 'Schimbarea modului a fost refuzată'
      },
      pin: {
        address: 'Adresă public (pin opțional)',
        clusterAddress: 'Adresă cluster (pin opțional)',
        autoPlaceholder: 'automat în subrețeaua {cidr}',
        hint: 'Adresare per-daemon: gol = Ceph se leagă singur în rețeaua declarată; completat = această instanță de daemon este fixată (pin) la adresa din secțiunea ei de conf.'
      },
      addMon: {
        title: 'Adaugă nod',
        node: 'Nod',
        address: 'Adresă public',
        addressHint: 'Adresele nodului pe care IPAM le cunoaște în subrețeaua public — automat când o declarație existentă acoperă nodul.',
        clusterAddress: 'Adresă cluster',
        clusterAddressHint: 'Obligatoriu: subrețeaua cluster este separată, iar nodul nu este încă declarat pe ea.',
        noAddresses: 'IPAM nu cunoaște nicio adresă a acestui nod în subrețea',
        error: 'Adăugarea mon-ului a fost refuzată'
      },
      removeMon: {
        title: 'Elimină MON',
        body: 'MON-ul și MGR-ul lui colocat părăsesc nodul {node}. Pe un cluster implementat, daemonii sunt opriți și eliminați din cvorum.',
        error: 'Eliminarea MON-ului a fost refuzată'
      },
      addMgr: {
        title: 'Adaugă MGR',
        node: 'Nod',
        hint: 'Avansate (MON/MGR disjuncți): un manager standalone se naște pe nodul membru ales printr-un task cu afinitate pe nod. Alegerea active/standby proprie lui Ceph desemnează singură MGR-ul activ.',
        error: 'Adăugarea MGR-ului a fost refuzată'
      },
      removeMgr: {
        title: 'Elimină MGR',
        body: 'MGR-ul standalone părăsește nodul {node}. Pe un cluster implementat, daemonul este oprit și starea lui eliminată; MON-ul nodului (dacă există) nu este atins.',
        error: 'Eliminarea MGR-ului a fost refuzată'
      },
      addMds: {
        title: 'Adaugă MDS',
        node: 'Nod',
        hint: 'Metadata serverul CephFS-ului: se naște pe nodul membru ales printr-un task cu afinitate pe nod, supervizat de worker ca MON și MGR. Ceph își alege singur activii și standby-urile — un activ plus un standby servesc bine un sistem de fișiere.',
        error: 'Adăugarea MDS-ului a fost refuzată'
      },
      removeMds: {
        title: 'Elimină MDS',
        body: 'MDS-ul părăsește nodul {node}. Pe un cluster implementat, daemonul este oprit și starea lui eliminată; API-ul refuză ultimul MDS cât timp un sistem de fișiere are nevoie de el.',
        error: 'Eliminarea MDS-ului a fost refuzată'
      },
      split: {
        title: 'MON/MGR disjuncți',
        label: 'Permite MON și MGR pe noduri disjuncte',
        hint: 'Dezactivat (implicit) = standardul ratificat: un MGR rulează colocat cu fiecare MON, un singur membership. Activat = membership-ul MGR devine unul propriu, gestionat cu acțiunile Adaugă/Elimină MGR din fila Noduri de management.',
        enable: 'Activează',
        disable: 'Dezactivează',
        enableBody: 'Membership-ul MGR devine independent de MON-uri, inițializat din colocarea actuală. Acțiunile Adaugă/Elimină MGR se activează în fila Noduri de management. Aceasta relaxează setarea implicită a platformei — păstreaz-o doar dacă știi de ce ai nevoie de ea.',
        disableBody: 'Înapoi la colocarea standard: un MGR cu fiecare MON, un singur membership. Legal doar dacă membership-ul MGR coincide deja cu MON-urile — aliniază-l mai întâi cu Adaugă/Elimină MGR, altfel API-ul va refuza.',
        error: 'Modificarea a fost refuzată'
      },
      rawEditor: {
        title: 'Editor CRUSH brut',
        label: 'Arată editorul brut al crushmap-ului în fila CRUSH',
        hint: 'Dezactivat (implicit) = suprafața ghidată de reguli este instrumentul standard. Activat = fila CRUSH arată și crushmap-ul decompilat ca text editabil. Salvarea cere întotdeauna sudo, numele clusterului drept confirmare, și trece prin compile + test cu crushtool ÎNAINTE de a ajunge la cluster.'
      },
      osdFlags: {
        section: 'Flaguri OSD globale',
        title: 'Override flaguri OSD',
        notObserved: 'încă neobservate',
        standardFlowsHint: 'Fluxurile standard ale platformei gestionează singure aceste flaguri în cazurile normale (mentenanța unui nod setează un noout țintit, înlocuirea unui disc trece prin ciclul de viață OSD). Această secțiune este override-ul manual pentru operatorul care știe ce face.',
        notDeployedGuard: 'Flagurile OSD există doar pe un cluster implementat',
        set: 'Setează flag',
        unset: 'Elimină flag',
        setBody: 'Flagul global {flag} va fi SETAT pe osdmap. Rămâne până când este eliminat explicit — un flag uitat degradează auto-vindecarea clusterului.',
        unsetBody: 'Flagul global {flag} va fi ELIMINAT de pe osdmap.',
        error: 'Modificarea flagului a fost refuzată',
        flag: {
          noout: 'Niciun OSD nu este marcat out din distribuția datelor — nicio reechilibrare la pierderea unui daemon',
          norebalance: 'Reechilibrarea datelor este suspendată',
          nobackfill: 'Backfill-ul este suspendat',
          norecover: 'Recovery-ul este suspendat',
          pause: 'TOT I/O-ul clienților este pus pe pauză (citiri și scrieri)',
          noin: 'OSD-urile care pornesc nu sunt marcate in automat',
          nodown: 'OSD-urile inaccesibile nu sunt marcate down — maschează defecțiuni reale'
        }
      },
      pools: {
        section: 'Pool-uri',
        create: 'Creează pool',
        createGuard: 'Pool-urile există doar pe un cluster implementat',
        notObserved: 'Nicio observație a pool-urilor — sweep-ul mon raportează aici',
        empty: 'Niciun pool pe cluster',
        colName: 'Nume',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Aplicație',
        colRule: 'Regulă CRUSH',
        colUsage: 'Utilizare',
        observedAtLabel: 'Observat la',
        objects: 'obiecte: {n}',
        inUseBy: 'folosit de {name}',
        internalGuard: 'Pool intern al lui Ceph — platforma nu îl șterge niciodată',
        delete: 'Șterge pool-ul',
        deleteGuard: 'Consumat de storage-ul {name} — șterge mai întâi storage-ul',
        hint: 'Doar pool-uri replicate (erasure coding în afara scope-ului v1). Replicarea trăiește în Ceph: acest tabel este adevărul observat de sweep-ul mon.',
        createTitle: 'Creează pool',
        createHint: 'Pool-ul se naște pe cluster cu replicarea cerută și aplicația rbd activată — treaba o face un task pe un nod MON. Activează „Propune ca storage” pentru a-l consuma imediat, în același gest.',
        name: 'Numele pool-ului',
        nameHint: 'DNS-safe (litere mici, cifre, cratime).',
        size: 'Replici (size)',
        sizeHint: 'Copii ale fiecărui obiect. Implicit 3.',
        minSize: 'Replici minime (min_size)',
        minSizeHint: 'Numărul minim de copii pentru a servi I/O — urmează size − 1 până când îl modifici.',
        createError: 'Crearea pool-ului a fost refuzată',
        deleteTitle: 'Șterge pool-ul',
        deleteBody: 'Pool-ul {pool} și FIECARE obiect din el sunt distruse ireversibil. Tastează numele pool-ului pentru a confirma.',
        confirmLabel: 'Numele pool-ului',
        confirmHint: 'Tastează numele pool-ului pentru a confirma',
        deleteError: 'Ștergerea pool-ului a fost refuzată',
        detailTitle: 'Detalii pool',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Activat',
        autoscalerOff: 'Dezactivat',
        autoscalerWarn: 'Notifică',
        pgNumLabel: 'Număr de PG',
        pgNumCaption: 'Observat: autoscalerul îl poate schimba singur — acest câmp scrie o dorință.',
        storage: 'Storage TVirt asociat',
        addAsStorage: 'Adaugă ca storage TVirt',
        ruleSudoHint: 'Schimbarea regulii CRUSH cere parola operatorului.',
        updateError: 'Modificarea pool-ului a fost refuzată',
        updated: 'Modificarea pool-ului a pornit — observația se actualizează singură'
      },
      crush: {
        section: 'Reguli CRUSH',
        notObserved: 'Nicio observație CRUSH încă — sweep-ul mon raportează aici',
        empty: 'Nicio regulă observată pe cluster',
        hint: 'O regulă decide UNDE ajung copiile fiecărui obiect — domeniul ei de defecțiune este unitatea care poate ceda fără pierdere de date. Pool-urile arată spre o regulă; replicated_rule builtin (o replică per server) este implicitul de la naștere.',
        create: 'Creează regulă',
        createGuard: 'Regulile CRUSH există doar pe un cluster implementat',
        createTitle: 'Creează regulă CRUSH',
        createHint: 'O regulă = o alegere de domeniu de defecțiune. Regula se naște replicată pe root-ul implicit — treaba o face un task pe un nod MON; asociază pool-urile din fila Pool-uri după aceea.',
        createError: 'Crearea regulii a fost refuzată',
        name: 'Numele regulii',
        nameHint: 'DNS-safe (litere mici, cifre, cratime).',
        domain: 'Domeniu de defecțiune',
        domainChoice: {
          osd: 'Fiecare replică pe un OSD diferit',
          host: 'Fiecare replică pe un server diferit',
          rack: 'Fiecare replică într-un rack diferit'
        },
        domainCustom: 'Personalizată (pași scriși de mână)',
        domainOther: 'Fiecare replică într-un {type} diferit',
        rackGuardHint: 'Niciun bucket rack nu există în ierarhia observată: regula poate fi creată oricum, dar niciun pool nu va putea fi îndreptat spre ea până când un rack nu este declarat în plasarea serverelor membre (setările nodului) — taskul de realiniere construiește bucketul, iar asocierea se deschide de la sine.',
        treeTitle: 'Ierarhie observată',
        treeNotObserved: 'Nicio observație a ierarhiei — sweep-ul mon raportează aici',
        treeOsds: '{n} OSD',
        treeHint: 'Harta CRUSH așa cum o vede clusterul: root → nivelurile declarate → servere (hosturi) → OSD. Topologia urmează plasarea declarată a fiecărui server (setările nodului) — o schimbare de poziție o realiniază printr-un task.',
        unplacedWarning: 'Membri fără poziție declarată: {nodes} — bucketurile lor host rămân direct sub root, în afara topologiei declarate. Declară poziția în setările nodului (un avertisment, niciodată un blocaj).',
        colName: 'Nume',
        colDomain: 'Domeniu de defecțiune',
        colPools: 'Pool-uri',
        builtinChip: 'builtin',
        builtinGuard: 'Regula implicită a clusterului — platforma nu o șterge niciodată',
        detailAction: 'Detaliu regulă',
        detailType: 'Tip',
        backToRules: 'Reguli',
        ruleNotObserved: 'Lista observată de reguli nu numește această regulă',
        noPools: 'Niciun pool nu folosește această regulă',
        delete: 'Șterge regula',
        deleteTitle: 'Șterge regula CRUSH',
        deleteBody: 'Regula {rule} este eliminată din crushmap-ul clusterului. Niciun pool nu trebuie s-o folosească. Tastează numele regulii pentru a confirma.',
        deleteGuard: 'Folosită de pool-ul {name} — redirecționează mai întâi pool-ul',
        confirmLabel: 'Numele regulii',
        confirmHint: 'Tastează numele regulii pentru a confirma',
        deleteError: 'Ștergerea regulii a fost refuzată',
        changeRule: 'Schimbă regula CRUSH',
        changeRuleTitle: 'Schimbă regula CRUSH',
        changeRuleHint: 'Pool-ul începe să-și plaseze obiectele după regula aleasă — Ceph mută datele existente pentru a se conforma (pe un pool plin urmează o reechilibrare).',
        changeRuleError: 'Schimbarea regulii a fost refuzată',
        rule: 'Regulă CRUSH',
        rawTitle: 'Crushmap brut (decompilat)',
        rawWarning: 'PERICOL: acest text este ÎNTREAGA politică de plasare a clusterului. O hartă greșită poate rupe plasarea tuturor pool-urilor deodată. Salvarea compilează și testează harta cu crushtool ÎNAINTE de a o injecta — dar o hartă validă poate fi totuși o idee proastă.',
        rawReload: 'Reîncarcă',
        rawLoading: 'Query în curs — un task read-only decompilează crushmap-ul…',
        rawSave: 'Salvează crushmap-ul',
        rawSaveTitle: 'Injectează crushmap-ul',
        rawSaveBody: 'Textul editat înlocuiește crushmap-ul ÎNTREGULUI cluster după compile + test cu crushtool. Tastează numele clusterului pentru a confirma.',
        rawConfirmLabel: 'Numele clusterului',
        rawConfirmHint: 'Tastează {name} pentru a confirma',
        rawError: 'Operația pe crushmap a eșuat',
        rawHint: 'Textul este forma crushtool -d. Erorile de compilare și eșecurile de test se întorc cuvânt cu cuvânt de la crushtool — harta nu ajunge la cluster dacă oricare dintre cele două porți eșuează.'
      },
      objects: {
        poolsSection: 'Explorator de obiecte',
        poolsHint: 'Alege un pool pentru a-i lista imaginile RBD. Fiecare citire profundă rulează ca task read-only pe un nod MON — nu blochează (și nici nu este blocată de) operațiile reale.',
        deployedGuard: 'Query-urile pe obiecte răspund doar pe un cluster implementat',
        browse: 'Răsfoiește obiectele',
        detailAction: 'Detaliu imagine',
        backToPools: 'Pool-uri',
        backToImages: 'Imagini',
        refresh: 'Reîmprospătează',
        loading: 'Query în curs — un task read-only interoghează clusterul…',
        error: 'Query-ul a eșuat',
        retry: 'Reîncearcă',
        notRbd: 'Pool cu application "{app}" — nu conține imagini RBD, nimic de explorat aici',
        noImages: 'Nicio imagine RBD în acest pool',
        colImage: 'Imagine',
        colSize: 'Dimensiune',
        colObjects: 'Obiecte',
        colSnapshots: 'Snapshoturi',
        imagesHint: 'Discurile de pe un storage rbd consumator sunt imagini numite după id-ul discului lor. Numărul de obiecte este cel provisioned (dimensiune / dimensiunea obiectului) — utilizarea reală trăiește în detaliul imaginii.',
        infoTitle: 'Imagine',
        infoSize: 'Dimensiune virtuală',
        infoObjects: 'Obiecte (provisioned)',
        infoObjectSize: 'Dimensiunea obiectului',
        infoPrefix: 'Prefixul obiectelor',
        infoFormat: 'Format',
        infoFeatures: 'Feature-uri',
        usageTitle: 'Utilizare reală (rbd du)',
        usageOf: 'din {provisioned} GiB provisioned',
        usageHint: 'Thin prin natură: doar obiectele scrise ocupă octeți.',
        watchersTitle: 'Watcheri',
        noWatchers: 'Niciun watcher — nimeni nu are această imagine deschisă acum',
        snapshotsTitle: 'Snapshoturi RBD',
        noSnapshots: 'Niciun snapshot RBD pe această imagine',
        colSnapshot: 'Snapshot',
        colProtected: 'Protejat',
        colTimestamp: 'Creat',
        protected: 'protejat',
        mappingTitle: 'Maparea fizică (setul de OSD)',
        mappingSampled: 'Obiecte eșantionate: {sampled} din {total} — un rezumat onest: pentru imaginile mari setul converge către toate OSD-urile pool-ului (CRUSH distribuie obiectele pe întregul pool).',
        mappingComplete: 'Toate obiectele mapate ({total} din {total}).',
        objectQueryTitle: 'Mapează un singur obiect',
        objectName: 'Numele obiectului',
        objectHint: 'Numele obiectelor RADOS sunt <prefix>.<index 16-hex> — ceph osd map răspunde cu PG-ul și seturile de OSD.',
        mapObject: 'Mapează',
        primary: 'primar: osd.{osd}'
      },
      registerDevice: {
        title: 'Înregistrează dispozitiv OSD',
        hint: 'Pe un cluster viu, înregistrarea PREGĂTEȘTE și dispozitivul: devine un OSD BlueStore printr-un task automat cu afinitate pe nod (niciodată gol, ratificat 2026-07-24). Un dispozitiv aparține cel mult unui cluster Ceph din întreaga flotă.',
        disk: 'Disc de date',
        diskHint: 'Discurile de date declarate ale nodului — nume și număr de serie',
        noDeclared: 'Niciun disc de date declarat pe acest nod — marchează-le mai întâi în setările locale ale nodului',
        serialHint: 'Numărul de serie al dispozitivului — pinul de identitate',
        encrypted: 'Criptează acest OSD (dmcrypt)',
        encryptedHint: 'Alegerea per-OSD (modul clusterului este „aleasă per OSD”): îngheață pe acest disc la înregistrare — o schimbare ulterioară de mod nu o rescrie niciodată; o face acțiunea de rând criptează/decriptează.',
        error: 'Înregistrarea a fost refuzată'
      },
      unregisterDevice: {
        title: 'Anulează înregistrarea dispozitivului',
        body: 'Doar în registru: {name} încetează să mai fie un candidat OSD al acestui cluster. Octeții lui nu sunt atinși.',
        error: 'Anularea înregistrării a fost refuzată'
      },
      deploy: {
        action: 'Reîncearcă implementarea',
        title: 'Reîncearcă bootstrap-ul',
        body: 'Bootstrap-ul de naștere repornește din configurația actuală: MON-urile pornesc, fiecare dispozitiv înregistrat este pregătit și activat ca OSD BlueStore. Operația rulează ca macrotask — faza se actualizează singură.',
        started: 'Bootstrap pornit — continuă ca macrotask; faza se actualizează singură',
        error: 'Bootstrap-ul a fost refuzat'
      },
      propose: {
        action: 'Propune ca storage',
        title: 'Propune ca storage',
        hintPool: 'Pool-ul existent {name} devine un storage TVirt: o identitate cephx limitată la pool ajunge în keystore, iar storage-ul ceph-rbd se naște gata. Propunerea consumă pool-ul — nu creează niciodată unul.',
        hintFs: 'Sistemul de fișiere existent {name} devine un storage TVirt: o identitate cephx limitată la sistemul de fișiere ajunge în keystore, iar storage-ul cephfs se naște gata și montat. Propunerea consumă sistemul de fișiere — nu creează niciodată unul.',
        name: 'Numele storage-ului',
        nameHint: 'DNS-1123, unic în scope — identitatea cephx își ia numele de la el.',
        path: 'Cale în interiorul sistemului de fișiere',
        pathHint: 'Cale absolută în sistemul de fișiere pe care storage-ul îl montează — / dacă ai dubii.',
        alsoPropose: 'Propune imediat ca storage',
        alsoProposePoolHint: 'După creare, același gest propune pool-ul abia născut ca storage ceph-rbd — două apeluri explicite, un singur dialog.',
        alsoProposeFsHint: 'După creare, același gest propune sistemul de fișiere abia născut ca storage cephfs — două apeluri explicite, un singur dialog.',
        guard: 'Propune ca storage — doar pe un cluster healthy',
        started: 'Propunere acceptată — storage-ul se materializează; îl găsești sub Storage',
        submit: 'Creează storage',
        error: 'Propunerea a fost refuzată'
      },
      fs: {
        section: 'Sisteme de fișiere',
        create: 'Creează sistem de fișiere',
        createGuard: 'Sistemele de fișiere există doar pe un cluster implementat',
        mdsFirstGuard: 'Adaugă mai întâi un MDS — un sistem de fișiere fără metadata server se naște inutilizabil',
        notObserved: 'Nicio observație a sistemelor de fișiere — sweep-ul MON raportează aici',
        empty: 'Niciun sistem de fișiere pe cluster',
        colName: 'Nume',
        colPools: 'Pool-uri',
        colMds: 'MDS',
        noActiveMds: 'niciun MDS activ',
        delete: 'Elimină sistemul de fișiere',
        deleteGuard: 'Consumat de storage-ul {name} — șterge mai întâi storage-ul',
        hint: 'Un sistem de fișiere își deține pool-urile de date și de metadate (cephfs.<nume>.data / .meta): se nasc cu el și mor cu el — removeFs, niciodată o ștergere de pool făcută de mână. Acest tabel este adevărul observat de sweep-ul MON.',
        createTitle: 'Creează sistem de fișiere',
        createHint: 'Sistemul de fișiere se naște pe cluster cu cele două pool-uri ale lui (application cephfs) și este servit de MDS-urile declarate — treaba o face un task pe un nod MON. Activează „Propune ca storage” pentru a-l consuma imediat, în același gest.',
        name: 'Numele sistemului de fișiere',
        nameHint: 'DNS-safe (litere mici, cifre, cratime).',
        sizeHint: 'Replici pentru AMBELE pool-uri nou-născute. Implicit 3.',
        createError: 'Crearea sistemului de fișiere a fost refuzată',
        deleteTitle: 'Elimină sistemul de fișiere',
        deleteBody: 'Sistemul de fișiere {fs} și FIECARE fișier din el sunt distruse ireversibil — pool-urile lui de date și de metadate mor cu el. Tastează numele sistemului de fișiere pentru a confirma.',
        confirmLabel: 'Numele sistemului de fișiere',
        confirmHint: 'Tastează numele sistemului de fișiere pentru a confirma',
        deleteError: 'Eliminarea sistemului de fișiere a fost refuzată'
      },
      destroy: {
        action: 'Distruge',
        retryAction: 'Reîncearcă dezafectarea',
        retryGuard: 'Dezafectarea rulează — reîncercarea este pentru una eșuată (altfel lease-ul o refuză)',
        title: 'Distruge clusterul',
        body: 'Fabricul implementat este dezafectat: fiecare daemon al acestui cluster se oprește, starea lui de sistem și cheile din keystore sunt eliberate. Odată dezafectarea reușită, clusterul este eliminat automat.',
        confirmLabel: 'Numele clusterului',
        confirmHint: 'Tastează numele clusterului pentru a confirma',
        wipe: 'Șterge dispozitivele înregistrate',
        wipeHint: 'Bifat: semnăturile fiecărui dispozitiv înregistrat sunt șterse — datele de pe ele sunt distruse. Nebifat: octeții rămân intacți, iar dispozitivele revin la starea înregistrat.',
        guard: 'Distruge — nimic implementat',
        started: 'Distrugere pornită — continuă ca macrotask; faza se actualizează singură',
        error: 'Distrugerea a fost refuzată'
      },
      delete: {
        guard: 'Șterge — doar o configurație neimplementată (întâi distruge)',
        title: 'Ștergi {name}?',
        body: 'Configurația și registrul ei de dispozitive sunt eliminate. Legal doar cât timp nimic nu este implementat.',
        error: 'Ștergerea a fost refuzată'
      }
    }
  }
}
